import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import PlotCategory from "@/pages/category/plot/page";
import CastCategory from "@/pages/category/cast/page";
import ReviewCategory from "@/pages/category/reviews/page";
import NewsCategory from "@/pages/category/news/page";
import Detail from "@/pages/detail/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/plot",
        element: <PlotCategory />,
      },
      {
        path: "category/cast",
        element: <CastCategory />,
      },
      {
        path: "category/reviews",
        element: <ReviewCategory />,
      },
      {
        path: "category/news",
        element: <NewsCategory />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;